// src/components/Calendar/HorarioCalendar.js
import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import HorarioCustomToolbar from "./HorarioCustomToolbar";
import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import styles from "./HorarioCalendar.module.css";
import PersonIcon from "../../assets/svgs/person.svg";


moment.locale("es");
const localizer = momentLocalizer(moment);


const HorarioCalendar = ({ tardes = [], isAdmin, selectedWeek, onDateSelect, onDaySelect }) => {
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const isInSelectedWeek = (date) => {
    if (!selectedWeek?.start || !selectedWeek?.end) return false;
    const current = moment(date).format("YYYY-MM-DD");
    return current >= selectedWeek.start && current <= selectedWeek.end;
  };

  useEffect(() => {
    const mappedEvents = tardes.map((item) => ({
      title: `${item.Empleado}`,
      start: moment(item.Fecha).startOf("day").toDate(),
      end: moment(item.Fecha).endOf("day").toDate(),
      color: "#99C643B2",
    }));
    setCalendarEvents(mappedEvents);
  }, [tardes]);

  const messages = {
    today: "Hoy",
    previous: "Anterior",
    next: "Siguiente",
    month: "Mes",
    week: "Semana",
    showMore: (total) => `${total} más`,
  };

  const selectDateAndWeek = (date) => {
    const formatted = moment(date).format("YYYY-MM-DD");
    setSelectedDate(formatted);
    onDaySelect?.(formatted);

    if (onDateSelect) {
      const monday = moment(date).startOf("isoWeek");
      const sunday = moment(date).endOf("isoWeek");
      onDateSelect({
        start: monday.format("YYYY-MM-DD"),
        end: sunday.format("YYYY-MM-DD"),
      });
    }
  };

  return (
    <div className={`${styles.calendarContainer}`}>
      <Calendar
        localizer={localizer}
        events={calendarEvents}
        startAccessor="start"
        endAccessor="end"
        selectable
        onSelectSlot={({ start }) => selectDateAndWeek(start)}
        onSelectEvent={(event) => selectDateAndWeek(event.start)}
        dayPropGetter={(date) => {
          const formatted = moment(date).format("YYYY-MM-DD");
          const classes = [];

          if (selectedWeek?.start && selectedWeek?.end) {
            const isSelectedWeek =
              formatted >= selectedWeek.start && formatted <= selectedWeek.end;

            if (isSelectedWeek) {
              classes.push(styles.weekGroup);
              if (formatted === selectedWeek.start) classes.push(styles.weekStart);
              if (formatted === selectedWeek.end) classes.push(styles.weekEnd);
            }
          }

          if (formatted === selectedDate) {
            classes.push(styles.selectedDay);
          }

          return { className: classes.join(" ") };
        }}
        style={{ height: "100%" }}
        views={{ month: true }}
        messages={messages}
        defaultView={Views.MONTH}
        components={{
          toolbar: (toolbarProps) => (
            <HorarioCustomToolbar {...toolbarProps} isAdmin={isAdmin} />
          ),
          event: ({ event }) => (
            <div className={styles.eventContainer}>
              <img src={PersonIcon} alt="Empleado" className={styles.eventIcon} />
              <span className={styles.eventText}>{event.title}</span>
            </div>
          ),
        }}
        eventPropGetter={() => ({
          style: {
            backgroundColor: "transparent",
            padding: "1px",
            marginLeft: "5px",
            marginBottom: "1px",
            cursor: "pointer",
          },
        })}
      />
    </div>
  );
};

export default HorarioCalendar;
